const PageHeader = ({ title, subtitle, actions, children }) => {
  return (
    <div className="page-header">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 sm:gap-4">
        <div className="min-w-0 flex-1">
          <h1 className="page-title">{title}</h1>
          {subtitle && <p className="page-subtitle">{subtitle}</p>}
        </div>
        {/* `flex-wrap` pe mobile ca butoanele multiple să curgă pe rând nou în loc să iasă din ecran. */}
        {actions && <div className="flex flex-wrap items-center gap-2 sm:gap-3">{actions}</div>}
      </div>
      {children}
    </div>
  );
};

export default PageHeader;
